import { GridColDef } from "@mui/x-data-grid";
import CityDetailButton from "./DetailButton";

export const userColumns: GridColDef[] = [
  {
    field: "",
    renderCell: CityDetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "id",
    minWidth: 150,
    headerName: "Id",
    sortable: false,
    filterable: true,
  },
  /*
  {
    field: "userName",
    headerName: "User Name",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "email",
    headerName: "Email",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "fullName",
    headerName: "Tam Ad",
    flex: 1,
    minWidth: 80,
  },
  */
  {
    field: "professionCode",
    headerName: "Branş",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "totalParticipation",
    headerName: "Tekrarlı Atama",
    flex: 1,
    type: "number",
    minWidth: 80,
  },
  {
    field: "isGraduationVerified",
    headerName: "Mezuniye Onay",
    flex: 1,
    type: "boolean",
    minWidth: 80,
  },
  {
    field: "emailConfirmed",
    headerName: "Email Onaylandı",
    flex: 1,
    type: "boolean",
    minWidth: 80,
  },
  {
    field: "accessFailedCount",
    headerName: "Başarısız Girişler",
    flex: 1,
    type: "number",
    minWidth: 80,
  },
  {
    field: "lastModificationTime",
    headerName: "Değiştirilme Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 180,
    valueGetter: (v, r) => new Date(v),
  },
  {
    field: "creationTime",
    headerName: "Oluşturulma Tarihi",
    type: "dateTime",
    flex: 1,
    minWidth: 180,
    valueGetter: (v, r) => new Date(v),
  },
];
